import * as React from 'react';
import * as classnames from 'classnames';
import { IOptionsButtonGroup } from './../FormConfigurator';

export default (props: IOptionsButtonGroup) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => props.onClick(e.target.value);
  return (
    <div className="radio-group" key={`${props.prefix}-group`}>
      {props.options.map(option => {
        const id = `${props.prefix}-${option.label}`;
        const className = classnames({
          disabled: option.disabled
        });
        return [
          <input
            type="radio"
            id={id}
            key={id}
            name={`${props.prefix}-group`}
            checked={option.isChecked}
            value={option.value}
            onChange={onChange}
            disabled={option.disabled}
          />,
          <label className={className} htmlFor={id} key={`${id}-label`}>
            {option.label}
          </label>
        ];
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Configurator/FormConfigurator/RadioForm.tsx